import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export function NotFoundScreen() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background">
      <h1 className="text-4xl font-bold mb-4">404</h1>
      <p className="text-xl mb-8">{t("notFound.message")}</p>
      <Button onClick={() => navigate("/")}>{t("notFound.backToHome")}</Button>
    </div>
  );
}
